/* tslint:disable */
/* eslint-disable */
/**
 * CMS
 * The CMS API description
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosResponse, AxiosInstance, AxiosRequestConfig } from "axios";
// @ts-ignore
import globalAxios from "@/config/axiosInstance";
import { Configuration } from "../configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
import { CreateCommentDto } from "../models";
import { DateNumber } from "../models";
import { EnumInteger } from "../models";
import { InsertCommentActionDTO } from "../models";
import { UpdateCommentDTO } from "../models";
/**
 * CommentApi - axios parameter creator
 * @export
 */
export const CommentApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {InsertCommentActionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    commentActionControllerInserCommentDislike: async (
      body: InsertCommentActionDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling commentActionControllerInserCommentDislike."
        );
      }
      const localVarPath = `/v1/cms/api/comment/dislike`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {InsertCommentActionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    commentActionControllerInserCommentLike: async (
      body: InsertCommentActionDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling commentActionControllerInserCommentLike."
        );
      }
      const localVarPath = `/v1/cms/api/comment/like`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateCommentDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    commentControllerCreateComment: async (
      body: CreateCommentDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling commentControllerCreateComment."
        );
      }
      const localVarPath = `/v1/cms/api/comment`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [contentKey]
     * @param {number} [userKey]
     * @param {EnumInteger} [state]
     * @param {DateNumber} [date]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    commentControllerGetComments: async (
      pageNumber: number,
      pageIndex: number,
      contentKey?: string,
      userKey?: number,
      state?: EnumInteger,
      date?: DateNumber,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageNumber' is not null or undefined
      if (pageNumber === null || pageNumber === undefined) {
        throw new RequiredError(
          "pageNumber",
          "Required parameter pageNumber was null or undefined when calling commentControllerGetComments."
        );
      }
      // verify required parameter 'pageIndex' is not null or undefined
      if (pageIndex === null || pageIndex === undefined) {
        throw new RequiredError(
          "pageIndex",
          "Required parameter pageIndex was null or undefined when calling commentControllerGetComments."
        );
      }
      const localVarPath = `/v1/cms/api/comment`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageNumber !== undefined) {
        localVarQueryParameter["pageNumber"] = pageNumber;
      }

      if (pageIndex !== undefined) {
        localVarQueryParameter["pageIndex"] = pageIndex;
      }

      if (contentKey !== undefined) {
        localVarQueryParameter["contentKey"] = contentKey;
      }

      if (userKey !== undefined) {
        localVarQueryParameter["userKey"] = userKey;
      }

      if (state !== undefined) {
        localVarQueryParameter["state"] = state;
      }

      if (date !== undefined) {
        localVarQueryParameter["date"] = date;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {InsertCommentActionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    commentControllerRemoveComment: async (
      body: InsertCommentActionDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling commentControllerRemoveComment."
        );
      }
      const localVarPath = `/v1/cms/api/comment`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpdateCommentDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    commentControllerUpdateComment: async (
      body: UpdateCommentDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling commentControllerUpdateComment."
        );
      }
      const localVarPath = `/v1/cms/api/comment`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CommentApi - functional programming interface
 * @export
 */
export const CommentApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {InsertCommentActionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async commentActionControllerInserCommentDislike(
      body: InsertCommentActionDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await CommentApiAxiosParamCreator(
        configuration
      ).commentActionControllerInserCommentDislike(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {InsertCommentActionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async commentActionControllerInserCommentLike(
      body: InsertCommentActionDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await CommentApiAxiosParamCreator(
        configuration
      ).commentActionControllerInserCommentLike(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {CreateCommentDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async commentControllerCreateComment(
      body: CreateCommentDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await CommentApiAxiosParamCreator(
        configuration
      ).commentControllerCreateComment(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [contentKey]
     * @param {number} [userKey]
     * @param {EnumInteger} [state]
     * @param {DateNumber} [date]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async commentControllerGetComments(
      pageNumber: number,
      pageIndex: number,
      contentKey?: string,
      userKey?: number,
      state?: EnumInteger,
      date?: DateNumber,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await CommentApiAxiosParamCreator(
        configuration
      ).commentControllerGetComments(
        pageNumber,
        pageIndex,
        contentKey,
        userKey,
        state,
        date,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {InsertCommentActionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async commentControllerRemoveComment(
      body: InsertCommentActionDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await CommentApiAxiosParamCreator(
        configuration
      ).commentControllerRemoveComment(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {UpdateCommentDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async commentControllerUpdateComment(
      body: UpdateCommentDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await CommentApiAxiosParamCreator(
        configuration
      ).commentControllerUpdateComment(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * CommentApi - factory interface
 * @export
 */
export const CommentApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {InsertCommentActionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async commentActionControllerInserCommentDislike(
      body: InsertCommentActionDTO,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return CommentApiFp(configuration)
        .commentActionControllerInserCommentDislike(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {InsertCommentActionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async commentActionControllerInserCommentLike(
      body: InsertCommentActionDTO,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return CommentApiFp(configuration)
        .commentActionControllerInserCommentLike(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateCommentDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async commentControllerCreateComment(
      body: CreateCommentDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return CommentApiFp(configuration)
        .commentControllerCreateComment(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [contentKey]
     * @param {number} [userKey]
     * @param {EnumInteger} [state]
     * @param {DateNumber} [date]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async commentControllerGetComments(
      pageNumber: number,
      pageIndex: number,
      contentKey?: string,
      userKey?: number,
      state?: EnumInteger,
      date?: DateNumber,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return CommentApiFp(configuration)
        .commentControllerGetComments(
          pageNumber,
          pageIndex,
          contentKey,
          userKey,
          state,
          date,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {InsertCommentActionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async commentControllerRemoveComment(
      body: InsertCommentActionDTO,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return CommentApiFp(configuration)
        .commentControllerRemoveComment(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpdateCommentDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async commentControllerUpdateComment(
      body: UpdateCommentDTO,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return CommentApiFp(configuration)
        .commentControllerUpdateComment(body, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * CommentApi - object-oriented interface
 * @export
 * @class CommentApi
 * @extends {BaseAPI}
 */
export class CommentApi extends BaseAPI {
  /**
   *
   * @param {InsertCommentActionDTO} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */
  public async commentActionControllerInserCommentDislike(
    body: InsertCommentActionDTO,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return CommentApiFp(this.configuration)
      .commentActionControllerInserCommentDislike(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {InsertCommentActionDTO} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */
  public async commentActionControllerInserCommentLike(
    body: InsertCommentActionDTO,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return CommentApiFp(this.configuration)
      .commentActionControllerInserCommentLike(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {CreateCommentDto} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */
  public async commentControllerCreateComment(
    body: CreateCommentDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return CommentApiFp(this.configuration)
      .commentControllerCreateComment(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {number} pageNumber
   * @param {number} pageIndex
   * @param {string} [contentKey]
   * @param {number} [userKey]
   * @param {EnumInteger} [state]
   * @param {DateNumber} [date]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */
  public async commentControllerGetComments(
    pageNumber: number,
    pageIndex: number,
    contentKey?: string,
    userKey?: number,
    state?: EnumInteger,
    date?: DateNumber,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return CommentApiFp(this.configuration)
      .commentControllerGetComments(
        pageNumber,
        pageIndex,
        contentKey,
        userKey,
        state,
        date,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {InsertCommentActionDTO} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */
  public async commentControllerRemoveComment(
    body: InsertCommentActionDTO,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return CommentApiFp(this.configuration)
      .commentControllerRemoveComment(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {UpdateCommentDTO} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */
  public async commentControllerUpdateComment(
    body: UpdateCommentDTO,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return CommentApiFp(this.configuration)
      .commentControllerUpdateComment(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
